import { render, staticRenderFns } from "./TagManagement.vue?vue&type=template&id=31715b85&scoped=true"
import script from "./TagManagement.vue?vue&type=script&lang=js"
export * from "./TagManagement.vue?vue&type=script&lang=js"
import style0 from "./TagManagement.vue?vue&type=style&index=0&id=31715b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31715b85",
  null
  
)

export default component.exports